<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Pindah Gudang</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Gudang Asal">
                        <b-form-select v-model="filter.warehouseFrom" :options="optFilterWarehouse" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Gudang Tujuan">
                        <b-form-select v-model="filter.warehouseTo" :options="optFilterWarehouse" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <!-- <b-form-group label="Customer">
                        <multiselect v-model="filter.customer"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optCustomer"
                        />
                    </b-form-group> -->
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Perpindahan Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Perpindahan Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button class="ml-2" variant="dark" @click="calculateTotal()">
                            <i class="fa fa-calculator mr-2" />Total
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" class="ml-2" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Pindah Gudang Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data pindah gudang.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.no_faktur || "--DRAFT--" }}
                    <div class="small text-muted">
                        {{ row.item.no_ref || "-" }}<br />
                    </div>
                </template>
                <template v-slot:cell(detail)="row">
                    Tanggal Faktur: {{ row.item.move_date || "-" }}
                    <div class="small text-muted">
                        Draft: {{ row.item.created_by }} - {{ $helper.parseDate(row.item.created) }}, {{
            $helper.parseHourMinute(row.item.created) }}
                    </div>
                    <div class="small text-muted" v-if="row.item.move_date">
                        Selesai: {{ row.item.confirmed_by }} - {{ $helper.parseDate(row.item.confirmed) }}, {{
            $helper.parseHourMinute(row.item.confirmed) }}
                    </div>
                </template>
                <template v-slot:cell(warehouse)="row">
                    <div class="small">
                        Asal: Gudang {{ row.item.from }} - {{ row.item.from_office }}<br>
                        Tujuan: Gudang {{ row.item.to }} - {{ row.item.to_office }}<br>
                    </div>
                    <div class="small text-muted">
                        {{ row.item.details_count }} unit barang - {{ row.item.division }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{ getStatusBadge(row.item.status)[1]
                        }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link v-if="row.item.status == 1" :to="'pindah-gudang/draft/' + row.item.id">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lanjut Draft">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link v-if="[2, 3].includes(row.item.status)" :to="'pindah-gudang/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Pindah Gudang">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                    <!-- <b-button v-if="[2, 3].includes(row.item.status)" class="ml-2" size="sm" variant="dark" v-b-tooltip.hover.top title="Pembayaran" @click="showPayments(row.item)">
                        <i class="fa fa-fw fa-dollar" />
                    </b-button> -->
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Pindah Gudang Baru" centered no-close-on-backdrop hide-footer>
            <b-form-group label="Perpindahan barang dari gudang...">
                <multiselect v-model="input.warehouseFrom" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optWarehouse" />
            </b-form-group>
            <b-form-group label="Perpindahan barang menuju gudang...">
                <multiselect v-model="input.warehouseTo" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optWarehouseTo" />
            </b-form-group>
            <b-form-group label="Divisi barang...">
                <multiselect v-model="input.division" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optDivisions" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="createPindahGudang">
                    {{ isSubmitting ? "Membuat..." : "Pindah Gudang Baru" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-calculate" title="Perhitungan Totalan" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.warehouseFrom != null && calculateTotalData.warehouseTo != null">
                    Asal: <strong>{{ calculateTotalData.warehouseFrom }}</strong><br />
                    Tujuan: <strong>{{ calculateTotalData.warehouseTo }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Faktur: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang: <strong>{{ calculateTotalData.total_items }}</strong> barang
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            calculateTotalData: {},

            filter: {
                noFaktur: "",
                status: -1,
                startDate: "",
                endDate: "",
                warehouseFrom: "",
                warehouseTo: ""
            },

            input: {
                warehouseFrom: null,
                warehouseTo: null,
                division: null
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "noFaktur", label: "No. Faktur Pindah Gudang", sortable: true },
                { key: "detail", label: "Detail Dokumen", sortable: true },
                { key: "warehouse", label: "Informasi Gudang", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Selesai" }
            ],

            optFilterWarehouse: [],

            optWarehouse: [],
            optWarehouseTo: [],

            optDivisions: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optFilterWarehouse = [
                    { value: "", text: "Semua" }
                ]
                res.data.data.map(item => {
                    this.optFilterWarehouse.push({
                        value: item.id,
                        text: item.name + " - " + item.office_name
                    })
                    this.optWarehouse.push({
                        id: item.id,
                        name: item.name + " - " + item.office_name
                    })
                })
            })

            let getWarehouseTo = this.$axios.get("master/warehouses").then(res => {
                this.optWarehouseTo = res.data.data.map(item => {
                    return {
                        id: item.id,
                        name: item.name + " - " + item.office_name
                    }
                });
            })

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                this.optDivisions = res.data.data
            })

            Promise.all([getItems, getWarehouses, getDivisions, getWarehouseTo]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    this.initStatus = -1
                })

        },

        createPindahGudang() {

            if (this.input.warehouseFrom == null || this.input.warehouseTo == null) {
                return this.$helper.toastError(this, "Mohon memilih gudang!")
            }

            if (this.input.warehouseFrom.id == this.input.warehouseTo.id) {
                return this.$helper.toastError(this, "Tidak dapat memilih gudang yang sama!")
            }

            if (this.input.division == null) {
                return this.$helper.toastError(this, "Mohon memilih divisi barang!")
            }

            this.isSubmitting = true
            let payload = {
                warehouse_from: this.input.warehouseFrom.id,
                warehouse_to: this.input.warehouseTo.id,
                division_id: this.input.division.id
            }

            this.$axios.post("move-warehouse", payload).then(res => {
                let data = res.data.data
                this.$router.push({ path: "pindah-gudang/draft/" + data.id })

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if (this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if (!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if (!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if (!this.$helper.isBlank(this.filter.warehouseFrom)) {
                param += "&filterWarehouseFrom=" + this.filter.warehouseFrom
            }

            if (!this.$helper.isBlank(this.filter.warehouseTo)) {
                param += "&filterWarehouseTo=" + this.filter.warehouseTo
            }

            if (this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("move-warehouse" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listPindahBarangFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch (status) {
                case 1: return ["dark", "DRAFT"]
                case 2: return ["success", "SELESAI"]
                default: return ["light", "-"]
            }
        },

        calculateTotal() {

            let warehouseFilled = this.filter.warehouseFrom != "" && this.filter.warehouseTo != ""
            let dateFilled = this.filter.startDate != "" || this.filter.endDate != ""

            if (!warehouseFilled && !dateFilled) {
                return this.$helper.toastError(this, "Mohon mengisi minimal filter warehouse atau tanggal perpindahan!")
            }

            let param = ""

            if (this.filter.warehouseFrom != null && this.filter.warehouseTo != null) {
                param += "&filterWarehouseTo=" + this.filter.warehouseTo
                param += "&filterWarehouseFrom=" + this.filter.warehouseFrom
            }

            if (!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if (!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            this.isSubmitting = true
            this.$bvModal.show("m-calculate")

            this.$axios.get("move-warehouse/calculate?" + param).then(res => {
                this.calculateTotalData = res.data.data
                // sessionStorage.setItem("listPindahBarangFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.$bvModal.hide("m-calculate")
                })
                .finally(() => this.isSubmitting = false)
        }

    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listPindahBarangFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listPindahBarangFilter"))
        }
        this.init()
        this.$helper.toastFlash(this)
    }
}
</script>
